import Navbar from "@/components/Navbar";

const SECTIONS = [
  {
    title: "1. Objet",
    body: `Les présentes conditions générales d'utilisation (« CGU ») régissent l'accès et l'utilisation du site vanta-pulse.shop et des services VantaPulse : la vente, la configuration et la gestion de produits numériques (bots Discord, scripts pour serveurs FiveM...) sous forme d'abonnements ou de licences à vie. En créant un compte ou en utilisant le site, vous acceptez les présentes CGU.`,
  },
  {
    title: "2. Création de compte",
    body: `La création d'un compte nécessite un email valide et un mot de passe, ou une connexion via Google ou Discord. Vous êtes responsable de la confidentialité de votre mot de passe et, le cas échéant, de votre méthode d'authentification à deux facteurs. Toute activité effectuée depuis votre compte est réputée effectuée par vous ; contactez-nous immédiatement en cas d'accès non autorisé suspecté.`,
  },
  {
    title: "3. Description du service",
    body: `VantaPulse propose un catalogue de produits numériques (bots Discord, scripts pour serveurs FiveM...) disponibles sous forme de plans d'abonnement ou de licences à vie (durée et fonctionnalités variables selon le produit et le plan choisi). Les caractéristiques de chaque produit et de chaque plan sont décrites sur la page correspondante au moment de l'achat. Un script est fourni avec une clé de licence valable pour un seul serveur à la fois.`,
  },
  {
    title: "4. Prix et paiement",
    body: `Les prix sont indiqués en euros, toutes taxes comprises. Le paiement est traité par notre prestataire Stripe ; VantaPulse ne stocke aucune coordonnée bancaire. Des codes promotionnels peuvent être proposés et sont soumis aux conditions qui leur sont propres.`,
  },
  {
    title: "5. Droit de rétractation",
    body: `Conformément à la réglementation applicable aux contrats conclus à distance, vous disposez en principe d'un délai de 14 jours pour exercer votre droit de rétractation. Ce droit peut ne pas s'appliquer, ou s'appliquer différemment, une fois qu'un contenu ou service numérique a commencé à être fourni avec votre accord exprès. Pour toute demande de remboursement, contactez support@vantapulse.fr : chaque situation est étudiée individuellement.`,
  },
  {
    title: "6. Résiliation",
    body: `Vous pouvez désactiver ou supprimer définitivement votre compte à tout moment depuis Paramètres → Zone de danger. La désactivation est réversible en vous reconnectant ; la suppression est définitive. VantaPulse se réserve le droit de suspendre ou de bannir un compte en cas de violation des présentes CGU, notamment en cas d'usage frauduleux, abusif ou illégal du service.`,
  },
  {
    title: "7. Utilisation autorisée",
    body: `Vous vous engagez à utiliser le service et les produits fournis dans le respect des lois applicables et des conditions d'utilisation des plateformes concernées (Discord, FiveM...). Sont notamment interdits : l'usage du service à des fins illégales, la revente ou la redistribution non autorisée d'accès, de bots, de scripts ou de clés de licence, le spam, et toute tentative de contournement des mesures de sécurité du site ou de la vérification de licence.`,
  },
  {
    title: "8. Propriété intellectuelle",
    body: `Le site, la marque VantaPulse, ainsi que le code et le contenu des produits proposés (bots et scripts) restent la propriété de VantaPulse ou de ses ayants droit. Votre abonnement vous confère un droit d'usage pour la durée souscrite, à l'exclusion de tout transfert de propriété.`,
  },
  {
    title: "9. Disponibilité du service",
    body: `VantaPulse met tout en œuvre pour assurer la disponibilité du site et des produits, sans garantir une disponibilité ininterrompue (maintenance, mises à jour, ou indisponibilité de services tiers dont Discord et FiveM). VantaPulse ne saurait être tenu responsable des dysfonctionnements liés à des services tiers, notamment Discord et FiveM.`,
  },
  {
    title: "10. Assistant IA",
    body: `Le support proposé sur le site peut être assuré, en tout ou partie, par un assistant basé sur l'intelligence artificielle. Ses réponses sont fournies à titre informatif et peuvent, si nécessaire, être complétées ou corrigées par un membre de l'équipe support.`,
  },
  {
    title: "11. Responsabilité",
    body: `Dans les limites permises par la loi, VantaPulse ne pourra être tenu responsable des dommages indirects résultant de l'utilisation du service. Rien dans les présentes CGU ne vise à exclure une responsabilité qui ne peut être légalement exclue.`,
  },
  {
    title: "12. Modification des CGU",
    body: `VantaPulse peut modifier les présentes CGU pour refléter des évolutions du service ou de la réglementation. La date de dernière mise à jour est indiquée en haut de cette page. Une utilisation continue du service après modification vaut acceptation des nouvelles conditions.`,
  },
  {
    title: "13. Droit applicable",
    body: `Les présentes CGU sont soumises au droit français. Tout litige sera soumis aux tribunaux compétents, sous réserve des dispositions impératives protectrices du consommateur.`,
  },
  {
    title: "14. Contact",
    body: `Pour toute question relative aux présentes CGU : support@vantapulse.fr`,
  },
];

export default function TermsOfService() {
  return (
    <div className="min-h-screen bg-[#0a0a0f] text-white">
      <Navbar />
      <main className="pt-24 pb-16 max-w-4xl mx-auto px-6">
        <h1 className="text-3xl font-bold mb-2">Conditions d'utilisation</h1>
        <p className="text-white/40 text-sm mb-10">Dernière mise à jour : 24 septembre 2026</p>
        <div className="space-y-8">
          {SECTIONS.map((s) => (
            <section key={s.title}>
              <h2 className="text-xl font-semibold text-white mb-3">{s.title}</h2>
              <p className="text-white/60 leading-relaxed whitespace-pre-line">{s.body}</p>
            </section>
          ))}
        </div>
      </main>
    </div>
  );
}
